import parsePhoneNumber from 'libphonenumber-js'

const phoneNumberFormatter = phoneNumber => phoneNumber ? parsePhoneNumber(phoneNumber, 'US').formatNational() : '';

const toNationalNumber = phoneNumber => phoneNumber ? parsePhoneNumber(phoneNumber, 'US').nationalNumber : '';

export { phoneNumberFormatter, toNationalNumber };